import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';
import { normalizeInterfaceLanguage, supportedLanguages } from './languages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLanguages.map((item) => item.code),
    load: 'currentOnly',
    fallbackLng: 'zh-CN',
    debug: false,
    resources: messages,
    ns: ['translation', 'cinema'],
    defaultNS: 'translation',
    fallbackNS: ['cinema', 'translation'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'cinema:language',
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeInterfaceLanguage,
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (language) => {
  const normalized = normalizeInterfaceLanguage(language);
  document.documentElement.lang = normalized;
  try {
    localStorage.setItem('cinema:language', normalized);
  } catch {
    // Storage can be unavailable in private browsing.
  }
});

export default i18n;
